<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <!-- <div v-if="$gate.isBranchManager()"> -->
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->
            
    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>{{ $route.meta.title }}</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
			<br>
			<div class="col-lg-12">
				<div class="card card-primary card-outline">
					<div class="card-header">
						Create Coupon Campaign
					</div>
					<div class="card-body overflow-auto">
						<form @submit.prevent="createCampaign">
							<div class="form-group">
								<label>Company:</label>
								<v-select v-model="form.company_code" label="name" :options="companies" :reduce="companies => companies.code" placeholder="Select Company" @input="getBranches"></v-select>
								<span v-if="errors.company" :class="['badge bg-danger']">Please choose a company</span>
							</div>
							<div class="form-group">
								<label>Branch:</label>
								<v-select v-model="form.branch_code" label="branch" :options="branches" :reduce="branches => branches.branch_code" placeholder="Select Branch"></v-select>
								<span v-if="errors.branch" :class="['badge bg-danger']">Please choose a branch</span>
							</div>
							<div class="form-group">
								<label>Campaign:</label>
								<v-select v-model="form.campaign_id" label="name" :options="campaigns" :reduce="campaigns => campaigns.id" placeholder="Select Campaign"></v-select>
								<span v-if="errors.campaign_id" class="badge bg-danger">Please choose a campaign</span>
							</div>
							<div class="form-group">
								<label>Name</label>
								<input type="text" v-model="form.name" class="form-control" placeholder="Enter the name">
								<span v-if="errors.name" class="badge bg-danger">Please enter valid name</span>
							</div>
							<div class="form-group">
								<label>Start Date</label>
								<input type="date" v-model="form.start_date" class="form-control">
								<span v-if="errors.start_date" class="badge bg-danger">Please enter a valid start date</span>
							</div>
							<div class="form-group">
								<label>End Date</label>
								<input type="date" v-model="form.end_date" class="form-control">
								<span v-if="errors.end_date" class="badge bg-danger">Please enter a valid end date</span>
							</div>
							<div class="form-group">
								<label>Notes</label>
								<input type="text" v-model="form.notes" class="form-control" placeholder="Enter the notes">
								<span v-if="errors.notes" class="badge bg-danger">Please enter valid notes</span>
							</div>
							<div class="form-group">
								<button class="btn btn-primary" type="submit">Add</button>
							</div>
						</form>
					</div>
					<div class="card-footer">
						
					</div>
				</div>
			</div>
    </section>
    <!-- /.content -->


    
<!-- All VUE Parts end before this comment -->
        <!-- </div>
        <div v-if="!$gate.isBranchManager()">
             <access-denied></access-denied>
        </div> -->
    </div>
</template>

<script>
		 export default {
        mounted() {
            console.log('Component mounted.')
        },
        
        created(){
        	this.getCompanies();
        	this.getCampaigns();
        },
        
        data(){
        	return{
        		companies: [],
        		branches: [],
        		campaigns: [],
        		errors: [],
        		form: new Form({
        			company_code: '',
        			branch_code: '',
        			campaign_id: '',
        			start_date: '',
        			end_date: '',
        			notes: '',
        			name: ''
        		})
        	}
        },
        
        methods: {
        	getCompanies(){
        		axios.post("/api/getCompanies")
        		.then(response => {
        			this.companies = response.data;
        		});
        	},
        	
        	getBranches(){
        		axios.post("/api/getSAPBranches", {company: this.form.company_code})
        		.then(response => {
        			this.branches = response.data;
        		});
        	},
        	
        	getCampaigns(){
        		axios.post("/api/getMasterCampaigns")
        		.then(response => {
        			this.campaigns = response.data;
        		});
        	},
        	
        	createCampaign(){
        		this.form.post("/api/createCouponCampaign")
        		.then(() => {
        			toast.fire({
        				icon: 'success',
        				title: 'Coupon Campaign Created'
        			});
        			this.errors = [];
        		})
        		.catch((errors) => {
        			toast.fire({
        				icon: 'success',
        				title: 'Failed!'
        			});
        			this.errors = error.response.data.errors;
        		});
        	}
        }
    }
</script>
